import React, { useEffect, useState } from "react";
import MenuItemLayout from "./MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import mobileBanner from "../../../assets/images/intern-mob.png";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { toGetSurvey } from "../../../apis/actions/survey.actions";
import SurveyOverview from "../../../components/survey/SurveyOverview";
import Loader from "../../../biblio/Loader/Loader";
import { setTargeted, setType } from "../../../apis/slices/surveySlice";
const Survey = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { survey } = useSelector((state: RootState) => state.survey);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    dispatch(toGetSurvey(["general"]));
    dispatch(setTargeted(["general"]));
    dispatch(setType("external"));
    setTimeout(() => setLoading(false), 1000);
  }, [dispatch]);

  if (loading) return <Loader />;
  return (
    <MenuItemLayout
      mobileImage={mobileBanner}
      urlImage={banner}
      title="الرئيسية"
      subTitle="التقييم"
    >
      <div className="takaful--evaluation">
        <SurveyOverview
          survey={survey}
          loading={loading}
        />
      </div>
    </MenuItemLayout>
  );
};

export default Survey;
